import React, { useState, useRef, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
// --- Import Hooks
import useMakeRequest from "../../../hooks/useMakeRequest";
// --- Import Componenets
import Preloader from "../../../components/UI/Preloader/Preloader";
// --- Import Styles
import "./SubscriptionsListItem.sass";

function convertDate(date) {
  // The date comes in seconds. Here I cheat on her in milliseconds
  const dateMs = new Date(date * 1000);
  const formatedDate = new Intl.DateTimeFormat(window.navigator.language)
    .format(dateMs)
    .replaceAll(".", "/");

  return formatedDate;
}

function SubscriptionsListItem({ product }) {
  const checkboxId = useRef(Math.random() * 10000);
  const [setParams, result, isLoading, hasError, error] = useMakeRequest();
  const [isSubscribed, setIsSubscribed] = useState(
    product.cancel_autobilling === 0
  );
  const [settingsIsOpened, setSettingsIsOpened] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const sendSubscriptionStatus = useCallback(
    (productData, status) => {
      setParams({
        c: "accountStore",
        a: "userLicenseAutoBillingSetState",
        p: {
          lic_id: productData.id,
          status,
        },
      });
    },
    [setParams]
  );

  const enableSubscription = useCallback(() => {
    setIsSubscribed(true);
    sendSubscriptionStatus(product, true);
  }, [product, sendSubscriptionStatus]);

  const cancelSubscription = useCallback(() => {
    setShowConfirm(false);
    setIsSubscribed(false);
    sendSubscriptionStatus(product, false);
  }, [
    product,
    setParams,
    setShowConfirm,
    setIsSubscribed,
    sendSubscriptionStatus,
  ]);

  const closeConfirm = useCallback(() => {
    setShowConfirm(false);
  }, [setShowConfirm]);

  useEffect(() => {}, [result]);

  return (
    <tr
      className={`subscriptions-list-item ${
        settingsIsOpened ? "subscriptions-list-item--active" : ""
      }`}
    >
      <td className="subscriptions-list-item__cell">
        <p className="subscriptions-list-item__text">
          <strong>{product.name_prod} </strong>
          {product.license_name}
        </p>
      </td>
      <td className="subscriptions-list-item__cell">
        {(product.isCanRenew === true || product.license_dur_days < 365) && (
          <button
            className="button"
            onClick={() => {
              setSettingsIsOpened(!settingsIsOpened);
              setShowConfirm(false);
            }}
          >
            {settingsIsOpened ? (
              <span className="button__close" />
            ) : (
              <span className="button__dots" />
            )}
          </button>
        )}
        {(product.isCanRenew === true || product.license_dur_days < 365) && (
          <p className="subscriptions-list-item__text">
            Auto Renews {convertDate(product.license_expire_time)}
          </p>
        )}
        {(product.isCanRenew === true || product.license_dur_days < 365) &&
          settingsIsOpened && (
            <>
              <div className="setting">
                <p className="setting__text">Auto-Renewal</p>
                <div className="setting-checkbox">
                  <input
                    id={checkboxId.current}
                    type="checkbox"
                    className="setting-checkbox__input"
                    checked={isSubscribed}
                    onChange={() => {
                      return isSubscribed
                        ? setShowConfirm(true)
                        : enableSubscription();
                    }}
                  />
                  {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                  <label
                    aria-label="Cancel subscription"
                    htmlFor={checkboxId.current}
                    className="setting-checkbox__label"
                  />
                </div>
                {isLoading && !result && (
                  <Preloader
                    width="15px"
                    height="15px"
                    className="setting__loading"
                  />
                )}
              </div>
              {hasError && error !== "" && (
                <div className="setting__error">{error}</div>
              )}
            </>
          )}
        {showConfirm && (
          <div className="confirm">
            <button
              aria-label="Close confirm"
              className="confirm__close-btn"
              onClick={closeConfirm}
            />
            <p className="confirm__msg">
              Are you sure you want to cancel your auto-renewing subscription?
            </p>
            <div className="confirm__box">
              <button
                className="confirm__btn confirm__btn--yes"
                onClick={closeConfirm}
              >
                Cancel
              </button>
              <button
                className="confirm__btn confirm__btn--no"
                onClick={cancelSubscription}
              >
                Turn Off
              </button>
            </div>
          </div>
        )}
      </td>
    </tr>
  );
}

SubscriptionsListItem.propTypes = {
  product: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
  ).isRequired,
};

export default SubscriptionsListItem;
